import e from "@dialpad/dialtone-tokens/layered/themes/tokens-130-colors.css?inline";
//#region themes/130.js
var t = { brand: {
	css: e,
	name: "130"
} };
//#endregion
export { t as default };
